<template>
  <div class="declarationMain">
    <el-form ref="NewForm" :model="NewForm" :rules="rules" label-width="180px" style="margin: 40px 0;">
      <el-form-item label="申报项目名称：" prop="items_name">
        <el-input v-model="NewForm.items_name" :disabled="isDisabled"></el-input>
      </el-form-item>
      <el-form-item label="主申报单位：" prop="company_name">
        <el-input
          v-model="NewForm.company_name"
          @blur="isDeclareUnit"
          placeholder="请根据会员完整单位名称填写，如有疑问请电话咨询"
          :disabled="isDisabled"
        ></el-input>
        <span style="margin-left: 15px;color: #999;">须为协会会员单位，非会员请点击</span>
        <a href="http://117.74.136.106:18080/#/login" target="_blank" style="color: #00B0F0;">入会申请</a>
      </el-form-item>
      <el-form-item label="联合申报单位：" prop="unitecompanyList">
        <div
          v-for="(item, index) in NewForm.unitecompanyList"
          :key="index"
          style="margin-bottom: 5px;"
        >
          <el-input
            v-model="item.unite_company_name"
            @blur="isDeclareUnit2(index)"
            placeholder="请根据会员完整单位名称填写，如有疑问请电话咨询"
            :disabled="isDisabled"
          ></el-input>
          <i
            v-if="index === 0"
            class="el-icon-circle-plus-outline"
            style="font-size:30px;color: #ccc;vertical-align: middle;"
            @click="addUniteCompany"
          ></i>
          <i
            v-else
            class="el-icon-circle-close"
            style="font-size:30px;color: #ccc;vertical-align: middle;"
            @click="delUniteCompany(index)"
          ></i>
          <template v-if="index === 0">
            <span style="margin-left: 15px;color: #999;">须为协会会员单位，非会员请点击</span>
            <a
              href="http://117.74.136.106:18080/#/login"
              target="_blank"
              style="color: #00B0F0;"
            >入会申请</a>
          </template>
        </div>
      </el-form-item>
      <el-form-item required label="建设单位（业主单位）：" prop="constructioncompanyList">
        <div
          v-for="(item, index) in NewForm.constructioncompanyList"
          :key="index"
          style="margin-bottom: 5px;"
        >
          <el-input v-model="item.construction_company_name" :disabled="isDisabled"></el-input>
          <i
            v-if="index === 0"
            class="el-icon-circle-plus-outline"
            style="font-size:30px;color: #ccc;vertical-align: middle;"
            @click="addconstructioncompany"
          ></i>
          <i
            v-else
            class="el-icon-circle-close"
            style="font-size:30px;color: #ccc;vertical-align: middle;"
            @click="delconstructioncompany(index)"
          ></i>
        </div>
      </el-form-item>
      <el-form-item label="项目建设地点：" prop="construction_place">
        <el-input
          v-model="NewForm.construction_place"
          placeholder="XXX省（市）XXX 区（县）XXX"
          :disabled="isDisabled"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目竣工时间：" prop="construction_time">
        <el-date-picker
          value-format="yyyy-MM"
          v-model="NewForm.construction_time"
          type="month"
          placeholder="例：2018-11"
          :disabled="isDisabled"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="联系地址：" prop="address">
        <el-input v-model="NewForm.address" placeholder="请填写完整联系地址，以便沟通获奖情况" :disabled="isDisabled"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="主申报单位法人：" prop="legal_person">
            <el-input v-model="NewForm.legal_person" class="shortInput" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-left: -110px;">
          <el-form-item label="电话：" prop="legal_person_phone">
            <el-input
              v-model="NewForm.legal_person_phone"
              class="shortInput"
              placeholder="例：021-88888888"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人：" prop="linkman">
            <el-input
              v-model="NewForm.linkman"
              class="shortInput"
              placeholder="请认真填写联系人信息，以便沟通获奖情况"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-left: -110px;">
          <el-form-item label="职务：" prop="position">
            <el-input v-model="NewForm.position" class="shortInput" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邮箱：" prop="email">
            <el-input
              v-model="NewForm.email"
              class="shortInput"
              placeholder="123@qq.com"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-left: -110px;">
          <el-form-item label="手机：" prop="cellphone">
            <el-input
              v-model="NewForm.cellphone"
              class="shortInput"
              placeholder="请填写11位手机号码"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="座机：" prop="telephone">
            <el-input v-model="NewForm.telephone" class="shortInput" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-left: -110px;">
          <el-form-item label="传真：" prop="fax">
            <el-input v-model="NewForm.fax" class="shortInput" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="申报评定类型：" prop="award_type" v-if="this.$route.query.isUpgrade">
        <el-radio-group v-model="NewForm.award_type" :disabled="isDisabled">
          <el-radio :label="1" :disabled="NewForm.award <= 1">铂金奖</el-radio>
          <el-radio :label="2" :disabled="NewForm.award <= 2">金奖</el-radio>
          <el-radio :label="3" :disabled="NewForm.award <= 3">银奖</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="申报评定类型：" prop="award_type" v-else>
        <el-radio-group v-model="NewForm.award_type" :disabled="isDisabled">
          <el-radio :label="1">铂金奖</el-radio>
          <el-radio :label="2">金奖</el-radio>
          <el-radio :label="3">银奖</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="现有评定类型：" prop="award" required v-if="this.$route.query.isUpgrade">
        <el-radio-group v-model="NewForm.award" disabled>
          <el-radio :label="1">铂金奖</el-radio>
          <el-radio :label="2">金奖</el-radio>
          <el-radio :label="3">银奖</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="项目类型：" prop="project_type">
        <el-checkbox-group v-model="NewForm.project_type" class="checkboxMain" :disabled="isDisabled">
          <span class="color606266">居住建筑：</span>
          <el-row>
            <el-col>
              <el-checkbox label="7">商品房</el-checkbox>
              <el-checkbox label="8">保障性住房</el-checkbox>
              <el-checkbox label="9">宿舍</el-checkbox>
              <el-checkbox label="10">养老院或疗养院客房楼</el-checkbox>
              <el-checkbox label="11">幼儿园</el-checkbox>
              <el-checkbox label="12">招待所</el-checkbox>
              <el-checkbox label="14">其他</el-checkbox>
              <el-input
                v-model="NewForm.dwell_other"
                class="width200"
                style="margin-left: -15px;"
                :disabled="NewForm.project_type.indexOf('14') === -1"
              ></el-input>
            </el-col>
          </el-row>

          <p style="margin-top: 20px;" class="color606266">公共建筑：</p>
          <el-row>
            <el-col>
              <el-checkbox label="1">办公建筑</el-checkbox>
              <el-checkbox label="2">商业建筑</el-checkbox>
              <el-checkbox label="3">旅游建筑</el-checkbox>
              <el-checkbox label="4">科教文卫建筑</el-checkbox>
              <el-checkbox label="5">通信建筑</el-checkbox>
              <el-checkbox label="6">交通运输建筑</el-checkbox>
              <el-checkbox label="13">其他</el-checkbox>
              <el-input
                v-model="NewForm.public_other"
                :disabled="NewForm.project_type.indexOf('13') === -1"
                class="width200"
                style="margin-left: -15px;"
              ></el-input>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="本项目曾获奖励情况：">
        <table class="table">
          <thead>
            <tr>
              <th>获奖时间</th>
              <th>获奖名称</th>
              <th>获奖等级</th>
              <th>授奖部门</th>
              <th></th>
            </tr>
          </thead>
          <tbody id="trs">
            <tr v-for="(item, index) in awardList" :key="index">
              <td>
                <input
                  placeholder="例：2018-11"
                  v-model="item.bear_palm_time"
                  :disabled="isDisabled"
                  autocomplete="off"
                />
              </td>
              <td>
                <input v-model="item.bear_palm_name" :disabled="isDisabled" autocomplete="off" />
              </td>
              <td>
                <input v-model="item.bear_palm_grade" :disabled="isDisabled" autocomplete="off" />
              </td>
              <td>
                <input v-model="item.bear_palm_branch" :disabled="isDisabled" autocomplete="off" />
              </td>
              <td>
                <i
                  v-if="!index"
                  class="el-icon-circle-plus-outline"
                  @click="addRow"
                  style="font-size: 30px;color: #ccc;"
                />
                <i
                  v-else
                  class="el-icon-circle-close"
                  @click="delRow(index)"
                  style="font-size: 30px;color: #ccc;"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </el-form-item>

      <el-form-item label="项目概况:" prop="overview">
        <p class="color606266">(不少于200字)</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="NewForm.overview"
          style="width: 85%"
          :disabled="isDisabled"
        ></el-input>
      </el-form-item>
      <p
        style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
        class="color606266"
      >
        <span style="color: #f00;margin-right: 3px;">*</span>
        <i class="el-icon-upload"></i>
        至少上传3张高清图片：
      </p>
      <div class="picDivBox" v-if="isPreview">
        <div class="picDiv" v-for="(file, index) in NewForm.overviewPIC" :key="index + file.address">
          <img :src="downloadUrl + file.address" class="width100" />
        </div>
      </div>
      <ImgUploader
        v-if="!isPreview"
        :fileList="NewForm.overviewPICs"
        :handleChange="handleChange"
        :backFileList="NewForm.overviewPIC"
        :isDisabled="isDisabled"
        :delFromServer="delFromServer"
      />

      <el-form-item label="社会效益和经济效益:" prop="benefit" style="margin-top: 30px;">
        <p class="color606266">(不少于200字)</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="NewForm.benefit"
          style="width: 85%"
          :disabled="isDisabled"
        ></el-input>
      </el-form-item>
      <p
        style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
        class="color606266"
      >
        <i class="el-icon-upload"></i>上传相关图片：
      </p>
      <div class="picDivBox" v-if="isPreview">
        <div class="picDiv" v-for="(file, index) in NewForm.benefitPIC" :key="index + file.address">
          <img :src="downloadUrl + file.address" class="width100" />
        </div>
      </div>
      <ImgUploader
        v-if="!isPreview"
        :fileList="NewForm.benefitPICs"
        :handleChange="handleChange2"
        :backFileList="NewForm.benefitPIC"
        :isDisabled="isDisabled"
      />

      <el-form-item label="可操作性和示范性:" prop="operability" style="margin-top: 30px;">
        <p class="color606266">(不少于200字)</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="NewForm.operability"
          style="width: 85%"
          :disabled="isDisabled"
        ></el-input>
      </el-form-item>
      <p
        style="height:30px;margin-left: 180px;line-height: 20px;font-size: 14px;"
        class="color606266"
      >
        <i class="el-icon-upload"></i>上传相关图片：
      </p>
      <div class="picDivBox" v-if="isPreview">
        <div
          class="picDiv"
          v-for="(file, index) in NewForm.operabilityPIC"
          :key="index + file.address"
        >
          <img :src="downloadUrl + file.address" class="width100" />
        </div>
      </div>
      <ImgUploader
        v-if="!isPreview"
        :fileList="NewForm.operabilityPICs"
        :handleChange="handleChange3"
        :backFileList="NewForm.operabilityPIC"
        :isDisabled="isDisabled"
      />

      <el-form-item label="本企业郑重承诺：" style="margin-top: 30px;">
        <div class="promiseDivMain">
          <div class="promiseDiv" style="width: 48%;">
            <p>本次填报的《上海市既有建筑绿色更新改造评定申报表 》及全部附件材料的内容是真实的，如有虚假，本企业愿承担一切责任。</p>
            <br />
            <br />
            <div>主申报单位</div>
            <div>联合申报单位盖章</div>
            <div style="text-align: right;">
              年
              <span style="margin-left: 30px;">月</span>
              <span style="margin-left: 30px;">日</span>
            </div>
          </div>

          <div class="promiseDiv" style="margin-left: 4%;width: 48%;">
            <p>我司同意该项目申报上海市既有建筑绿色更新改造评定，并承诺本项目中的改造技术均已实施完成并投入使用。</p>
            <br />
            <br />
            <br />
            <div>建设单位（业主单位）盖章</div>
            <div style="text-align: right;">
              年
              <span style="margin-left: 30px;">月</span>
              <span style="margin-left: 30px;">日</span>
            </div>
          </div>
        </div>
      </el-form-item>
      <div style="margin-top: 30px;width: 85%">
        <div class="color606266" style="font-size: 14px;">上海市绿色建筑协会审核意见：</div>
        <div class="promiseDiv" style="width: 85%;margin-left: 180px;">
          <br />
          <br />
          <br />
          <br />
          <br />
          <div style="text-align: right;">上海市绿色建筑协会（盖章）</div>
          <div style="text-align: right;">
            年
            <span style="margin-left: 30px;">月</span>
            <span style="margin-left: 30px;">日</span>
          </div>
        </div>
      </div>
      <div v-if="isShowBtn" style="margin-top: 30px;display: flex;justify-content: center;">
        <el-button type="primary" @click="tempSave" v-if="!this.$route.query.isUpgrade" :loading="loading2">暂存</el-button>
        <el-button type="primary" v-if="this.$route.query.isUpgrade === 'true'" @click="next('NewForm')" :loading="loading">暂存</el-button>
        <el-button type="primary" v-else @click="next('NewForm')" :loading="loading">下一步</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import ImgUploader from './ImgUploader'
import { getUserInfo } from '../utils/cache'
import config from '../config'

const { downloadUrl } = config

// 电话验证
var validateLegalpersonphone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入电话'))
  } else if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)) {
    callback(new Error('电话格式不正确'))
  } else {
    callback()
  }
}
// 手机验证
var validateCellphone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入手机'))
  } else if (!/^1[3456789]\d{9}$/.test(value)) {
    callback(new Error('手机号格式不正确'))
  } else {
    callback()
  }
}

export default {
  name: 'declaration',
  props: [
    'isShowBtn',
    'form',
    'awardList',
    'isDisabled',
    'asyncGetEBByID',
    'isPreview',
    'backFileList1',
    'backFileList2',
    'backFileList3'
  ],
  components: {
    ImgUploader
  },
  data () {
    return {
      id: '',
      loading2: false,
      NewForm: this.form,
      NewAwardList: this.awardList,
      downloadUrl,
      loading: false,
      rules: {
        constructioncompanyList: [
          {
            validator: (rules, values, cb) => {
              if (values.some(item => !!item.construction_company_name)) {
                cb()
              } else {
                cb(new Error('请至少输入一个建设单位（业主单位）'))
              }
            },
            trigger: 'blur'
          }
        ],
        items_name: [
          { required: true, message: '请输入申报项目名称', trigger: 'blur' }
        ],
        company_name: [
          { required: true, message: '请输入主申报单位', trigger: 'blur' }
        ],
        construction_place: [
          { required: true, message: '请输入项目建设地点', trigger: 'blur' }
        ],
        construction_time: [
          { required: true, message: '请输入项目竣工时间', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        legal_person: [
          { required: true, message: '请输入主申报单位法人', trigger: 'blur' }
        ],
        legal_person_phone: [
          { required: true, message: '请输入电话' },
          { validator: validateLegalpersonphone, trigger: 'blur' }
        ],
        linkman: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        position: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        cellphone: [
          { required: true, message: '请输入手机号' },
          { validator: validateCellphone, trigger: 'blur' }
        ],
        award_type: [
          { required: true, message: '请选择申报评定类型', trigger: 'change' }
        ],
        project_type: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        overview: [
          { required: true, message: '请输入项目概况', trigger: 'blur' }
        ],
        benefit: [
          {
            required: true,
            message: '请输入社会效益和经济效益',
            trigger: 'blur'
          }
        ],
        operability: [
          { required: true, message: '请输入可操作性和示范性', trigger: 'blur' }
        ]
      },
      isPt: '' // 是否是铂金项目
    }
  },
  watch: {
    form (newData) {
      this.NewForm = newData
    },
    awardList (newData) {
      this.NewAwardList = newData
    }
  },
  methods: {
    delFromServer () {
      this.asyncGetEBByID()
    },
    // 判断是否为会员单位
    isDeclareUnit () {
      if (this.NewForm.company_name) {
        let params = {
          unitName: this.NewForm.company_name
        }
        API.isDeclareUnit(params).then(resp => {
          if (resp.resultCode === '0000') {
            if (resp.data === 'false') {
              this.$message.error('主申报单位须为会员单位！')
              this.NewForm.company_name = ''
            }
          }
        })
      }
    },

    isDeclareUnit2 (index) {
      if (this.NewForm.unitecompanyList[index].unite_company_name) {
        let params = {
          unitName: this.NewForm.unitecompanyList[index].unite_company_name
        }
        API.isDeclareUnit(params).then(resp => {
          if (resp.resultCode === '0000') {
            if (resp.data === 'false') {
              this.$message.error('联合申报单位须为会员单位！')
              this.NewForm.unitecompanyList[index].unite_company_name = ''
            }
          }
        })
      }
    },
    // 保存参数字段
    spitParams () {
      return {
        id: this.$route.query.id || this.id || '',
        user_id: getUserInfo().id, // 用户id
        items_name: this.NewForm.items_name, // 申报项目名称
        company_name: this.NewForm.company_name, // 主申报单位
        unite_company_name: this.NewForm.unitecompanyList
          .map(item => item.unite_company_name)
          .join(','), // 联合申报单位
        construction_company_name: this.NewForm.constructioncompanyList
          .map(item => item.construction_company_name)
          .join(','), // 建设单位（业主单位）
        construction_place: this.NewForm.construction_place, // 项目建设地点
        construction_time: this.NewForm.construction_time, // 项目竣工时间
        address: this.NewForm.address, // 联系地址
        legal_person: this.NewForm.legal_person, // 主申报单位法人
        legal_person_phone: this.NewForm.legal_person_phone, // 电话
        linkman: this.NewForm.linkman,
        position: this.NewForm.position,
        email: this.NewForm.email,
        cellphone: this.NewForm.cellphone,
        telephone: this.NewForm.telephone,
        fax: this.NewForm.fax,
        award_type: this.NewForm.award_type, // 申报评定类型
        award: this.$route.query.isUpgrade ? this.NewForm.award : '', // 现有类型
        overview: this.NewForm.overview,
        benefit: this.NewForm.benefit,
        operability: this.NewForm.operability,
        state: 10,
        overviewPICs: this.NewForm.overviewPICs,
        benefitPICs: this.NewForm.benefitPICs,
        operabilityPICs: this.NewForm.operabilityPICs,
        items: JSON.stringify(this.awardList), // 本项目曾获奖励情况
        project_type: this.NewForm.project_type,
        dwell_other: this.NewForm.dwell_other,
        public_other: this.NewForm.public_other
      }
    },
    // 暂存
    tempSave () {
      if (!this.NewForm.items_name) {
        this.$message.error('请填写申报项目名称')
        return
      }
      if (!this.NewForm.company_name) {
        this.$message.error('请填写主申报单位')
        return
      }
      let params = this.spitParams()
      this.loading2 = true
      API.createExistingbuildingDeclare(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.loading2 = false
          this.$message.success('保存成功!该申请已进入待提交')
          this.id = resp.data.id
          let params = {
            id: this.id
          }
          API.getEBByID(params).then(resp => {
            if (resp.resultCode === '0000') {
              this.NewForm = {
                ...resp.data,
                overviewPICs: [],
                benefitPICs: [],
                operabilityPICs: [],
                project_type: resp.data.project_type
                  ? resp.data.project_type.split(',')
                  : [],
                unitecompanyList: resp.data.unite_company_name
                  .split(',')
                  .map(item => ({ unite_company_name: item })),
                constructioncompanyList: resp.data.construction_company_name
                  .split(',')
                  .map(item => ({ construction_company_name: item }))
              }
              this.NewAwardList = !resp.data.projectWinHistoryDtos.length
                ? [
                  {
                    bear_palm_time: '',
                    bear_palm_name: '',
                    bear_palm_grade: '',
                    bear_palm_branch: ''
                  }
                ]
                : resp.data.projectWinHistoryDtos
            }
          })
        }
      })
    },
    // 下一步
    next (NewForm) {
      this.$refs[NewForm].validate((valid, error) => {
        if (valid) {
          if (this.NewForm.overview.length < 200) {
            this.$message.error('项目概况至少200字以上')
            return
          }
          if (this.NewForm.overviewPIC === null) {
            if (this.NewForm.overviewPICs.length < 3) {
              this.$message.error('项目概况相关图片至少上传3张')
              return
            }
          } else {
            if (
              this.NewForm.overviewPICs.length + this.NewForm.overviewPIC.length < 3
            ) {
              this.$message.error('项目概况相关图片至少上传3张')
              return
            }
          }
          if (this.NewForm.overview.length < 200) {
            this.$message.error('社会效益和经济效益至少200字以上')
            return
          }
          if (this.NewForm.overview.length < 200) {
            this.$message.error('可操作性和示范性至少200字以上')
            return
          }
          this.loading = true
          let params = this.spitParams()
          if (this.$route.query.isUpgrade) {
            API.backupExistingbuildingDeclare(params).then(resp => {
              if (resp.resultCode === '0000') {
                this.loading = false
                if (this.NewForm.award_type === 1) {
                  this.isPt = 'true'
                } else {
                  this.isPt = 'false'
                }
                this.$alert('您的升级申报已进入待提交项目', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    if (this.$route.query.isUpgrade === 'true') {
                      this.$router.push('/energy?id=' + resp.data.id + '&isPt=' + this.isPt)
                    } else {
                      this.$router.push('/energy?id=' + this.$route.query.id + '&isPt=' + this.isPt)
                    }
                  }
                })
              }
            })
          } else {
            API.createExistingbuildingDeclare(params).then(resp => {
              if (resp.resultCode === '0000') {
                this.loading = false
                if (this.NewForm.award_type === 1) {
                  this.isPt = 'true'
                } else {
                  this.isPt = 'false'
                }
                if (!this.$route.query.isUpdateInfo) {
                  this.$router.push('/energy?id=' + resp.data.id + '&isPt=' + this.isPt)
                } else {
                  this.$router.push('/energy?isUpdateInfo=true&id=' + this.$route.query.id + '&isPt=' + this.isPt)
                }
              }
            })
          }
        } else {
          let i = 20
          Object.keys(error).map(item => {
            this.$message({
              type: 'error',
              message: error[item][0].message,
              offset: i
            })
            i += 40
          })
        }
      })
    },
    addUniteCompany () {
      this.NewForm.unitecompanyList.push({ unite_company_name: '' })
    },
    delUniteCompany (index) {
      this.NewForm.unitecompanyList.splice(index, 1)
    },
    addconstructioncompany () {
      this.NewForm.constructioncompanyList.push({ construction_company_name: '' })
    },
    delconstructioncompany (index) {
      this.NewForm.constructioncompanyList.splice(index, 1)
    },
    // 文件改变时，调用上传接口
    handleChange (file) {
      this.NewForm.overviewPICs.push(file)
    },
    handleChange2 (file) {
      this.NewForm.benefitPICs.push(file)
    },
    handleChange3 (file) {
      this.NewForm.operabilityPICs.push(file)
    },
    addRow () {
      this.awardList.push({
        bear_palm_time: '',
        bear_palm_name: '',
        bear_palm_grade: '',
        bear_palm_granch: ''
      })
    },
    delRow (index) {
      this.awardList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.declarationMain {
  .picDivBox {
    margin-left: 180px;
    display: flex;
    height: 100px;
    white-space: nowrap;
    .picDiv {
      position: relative;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      .width100 {
        width: 100px;
        height: 100px;
      }
    }
  }
  .el-checkbox-group {
    font-size: 14px;
  }
  .el-form-item__label {
    white-space: nowrap;
  }
  .el-input {
    width: 480px;
  }
  .shortInput {
    width: 300px;
  }
  .width200 {
    width: 200px;
  }
  .checkboxMain {
    .el-checkbox__label {
      padding-left: 5px;
    }
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .el-table td,
  .el-table th {
    padding: 0;
  }
  .table {
    border: 1px solid rgba(233, 233, 233, 1);
    width: 85%;
    border-collapse: collapse;
    border-spacing: 0;
    font-weight: 400;
    tr td:last-child,
    thead th:last-child {
      border-bottom: hidden;
      border-right: hidden;
      border-top: hidden;
    }
    th {
      font-weight: 400;
      vertical-align: middle;
      color: #606266;
      border: 1px solid rgba(233, 233, 233, 1);
    }
    tr {
      text-align: center;
      border: 1px solid rgba(233, 233, 233, 1);
    }
    td {
      border: 1px solid rgba(233, 233, 233, 1);
      padding: 0 15px;
    }
    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: 0;
      background: none;
      color: #606266;
      font-size: inherit;
    }
  }
  .promiseDivMain {
    width: 85%;
    display: flex;
    margin-top: 30px;
  }
  .promiseDiv {
    background: rgba(250, 250, 250, 1);
    border: 1px solid rgba(233, 233, 233, 1);
    font-size: 16px;
    font-weight: 400;
    color: #999;
    padding: 10px;
    line-height: 30px;
    p {
      text-indent: 2em;
    }
  }
  .el-icon-circle-plus-outline:hover {
    cursor: pointer;
  }
  .el-icon-circle-close:hover {
    cursor: pointer;
  }
}
</style>
